import PropTypes from 'prop-types';
import {Enums} from '_app/utils';

const commentTypes = Enums.getType('commentTypes');

export default PropTypes.shape({
	Comment: PropTypes.string.isRequired,
	CommenterDisplayName:PropTypes.string.isRequired,
	ID: PropTypes.number.isRequired,
	ModifyDate: PropTypes.instanceOf(Date).isRequired,
	CreateDate: PropTypes.instanceOf(Date).isRequired,
	ParentID: PropTypes.string.isRequired,
	Type: PropTypes.oneOf([
		commentTypes.STORYBOARD,
		commentTypes.SHARECOPY,
		commentTypes.QUESTION,
		commentTypes.OTHER
	]).isRequired,
	UserID: PropTypes.string.isRequired
});